import React from "react";
import { STEPS } from "./constants";

const WizardStepIndicator = ({ step, setStep }) => (
  <div className="flex items-center gap-1 mb-5" data-testid="wizard-step-indicator">
    {STEPS.map((s, i) => {
      const Icon = s.icon;
      const active = i === step;
      const done = i < step;
      return (
        <React.Fragment key={s.key}>
          {i > 0 && <div className={`h-px flex-1 ${done ? "bg-blue-500" : "bg-slate-200"}`} />}
          <button
            onClick={() => i < step && setStep(i)}
            disabled={i > step}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all
              ${active ? "bg-blue-600 text-white shadow-sm" : done ? "bg-blue-100 text-blue-700 hover:bg-blue-200 cursor-pointer" : "bg-slate-100 text-slate-400"}`}
            data-testid={`wizard-step-${s.key}`}
          >
            <Icon className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">{s.label}</span>
          </button>
        </React.Fragment>
      );
    })}
  </div>
);

export default WizardStepIndicator;
